import React, { useState } from 'react';
import { avatarUrlOf, gradientFor, initialsOf } from './peopleUtils';

export const StaffAvatar = ({ staff, size = 'w-10 h-10', online, testId }) => {
  const [failed, setFailed] = useState(false);
  const url = !failed && avatarUrlOf(staff.avatar);
  return (
    <div className="relative flex-shrink-0">
      <div className={`${size} rounded-xl bg-gradient-to-br ${gradientFor(staff.username)} flex items-center justify-center overflow-hidden shadow-lg ${staff.is_suspended ? 'grayscale' : ''}`}>
        {url ? <img src={url} alt="" className="w-full h-full object-cover" onError={() => setFailed(true)} />
          : <span className="text-white text-xs font-bold">{initialsOf(staff.display_name || staff.username)}</span>}
      </div>
      {online && (
        <span className="absolute -bottom-0.5 -right-0.5 flex items-center justify-center" data-testid={testId} title="Active in the last 5 minutes">
          <span className="absolute w-3 h-3 rounded-full bg-emerald-400/70 animate-ping" />
          <span className="relative w-2.5 h-2.5 rounded-full bg-emerald-400 border-2 border-[#0a0a14]" />
        </span>
      )}
    </div>
  );
};
